module.exports = __webpack_public_path__ + "static/media/28.2fe07fac.jpg";